import React, {useState} from "react";
import {
    NavLink
} from "react-router-dom";
import "./navbar.css"
import './../../App.css'
import { MdKeyboardArrowDown } from 'react-icons/md'
import Logo from './../../Images/logo-05771722c25b257c52971d5243491863.png'
function Navbar() {
    const [toggle_icon, settoggleicon] = useState('bx bx-menu')
    const [listclass , setlistclass] = useState('');
    const [Navbarclass , setnavbarclass] = useState('Navbar')
    let toggle = () => {
        if(listclass === ""){
            setlistclass("menu-active");
            settoggleicon('bx bx-x')
        }else if (listclass === "menu-active"){
            setlistclass("")
            settoggleicon('bx bx-menu')
        }
    }
    document.addEventListener('scroll' , ()=>{
        if(window.scrollY > 90){
             setnavbarclass('Navbar is-sticky')
         } 
         else if (window.scrollY < 90){
            setnavbarclass("Navbar")
        }
    })

    return (
        <div className={Navbarclass}>  
            <div className="brand_logo">
                <NavLink to='/'><img src={Logo}/></NavLink>
            </div>
            <div id='toggle_btn' onClick={toggle}>
                <i className={toggle_icon}></i>
            </div>
                <ul className='menu_list' id={listclass}>
                <li className="list_item"><NavLink to="/">Home</NavLink></li>
                <li className="list_item">About Us<MdKeyboardArrowDown className='dropdown_arrow' />
                    <ul className="dropdown-menu">
                            <li><NavLink to='/aboutus'>About Us</NavLink></li>
                            <li><NavLink to='/ourteam'>Our Team</NavLink></li>
                    </ul>
                </li>
                <li className="list_item">Services<MdKeyboardArrowDown className='dropdown_arrow' /> 
                        <ul className='dropdown-menu'>
                            <li><NavLink to='/services/softwaredevelopment'>Software Develpment</NavLink></li>
                            <li><NavLink to='/services/webdevelopment'>Web Development</NavLink></li>
                            <li><NavLink to='/services/wordpress'>Wordpress</NavLink></li>
                            <li><NavLink to='/services/mobileappdevelopment'>Mobile App Development</NavLink></li>
                            <li><NavLink to='/services/productanddesign'>Product & Design</NavLink></li>
                            <li><NavLink to='/services/ecommerce'>Ecommerce</NavLink></li>
                    </ul>
                </li>
                <li className="list_item">Trainings<MdKeyboardArrowDown className='dropdown_arrow' /> 
                        <ul className='dropdown-menu'>
                            <li><NavLink href="non">Academy</NavLink></li>
                    </ul>
                </li>
                <li className="list_item">Career<MdKeyboardArrowDown className='dropdown_arrow' /> 
                        <ul className='dropdown-menu'>
                            <li><NavLink to='/career/intership'>Interships</NavLink></li>
                            <li><NavLink to='/carrer/jobs'>Jobs</NavLink></li>
                    </ul>
                </li>
                <li className="list_item">
                    <div className="Navbar_btn_main">
                            <NavLink className="button" to="/contact-us">Contact</NavLink>
                    </div> 
                </li>
            </ul>
        </div>

        )
}

export default Navbar;
